import { Component, OnInit } from '@angular/core';
import { Documento } from 'src/app/models/documento';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { DocumentosService } from 'src/app/services/documentos.service';

@Component({
  selector: 'app-cadastrar-anexo',
  templateUrl: './cadastrar-anexo.component.html',
  styleUrls: ['./cadastrar-anexo.component.scss']
})
export class CadastrarAnexoComponent implements OnInit {

  id = '';
  anexo = new Documento();
  editando = false;
  carregando = true;
  editavel = true;
  tipoSelecionado = 0;
  tipoSelecionadoDescricao: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private documentoService: DocumentosService
  ) {
    if (this.router.getCurrentNavigation().extras.state) {
      this.tipoSelecionado = this.router.getCurrentNavigation().extras.state.tipo;
      this.tipoSelecionadoDescricao = this.router.getCurrentNavigation().extras.state.tipoDescricao;
    }
  }

  ngOnInit(): void {
    if (this.route.snapshot.paramMap.get('id')) {
      this.id = this.route.snapshot.paramMap.get('id');
      this.editando = true;
      this.buscarAnexo();
    } else {
      this.anexo = new Documento();
      this.carregando = false;
    }
  }

  buscarAnexo() {
    this.carregandoService.mostra('buscaAnexo');

    this.documentoService.consultarPorIdDocumento(this.id).subscribe(doc => {
      this.anexo = doc;

      this.carregando = false;

      this.carregandoService.esconde('buscaAnexo');
    }, (erro) => {
      this.carregandoService.esconde('buscaAnexo');
      this.notificacaoService.erro(erro);
    });
  }

  salvar() {
    this.carregandoService.mostra('salvaAnexo');

    this.anexo.tipo = this.tipoSelecionado;

    this.documentoService.salvar(this.anexo).subscribe(() => {
      this.notificacaoService.sucesso('Anexo salvo com sucesso!!!');
      this.router.navigate(['/configuracoes/anexos'], { state: { tipo: this.tipoSelecionado } }).then(() => {
        this.carregandoService.esconde('salvaAnexo');
      });

    }, (erro) => {
      this.carregandoService.esconde('salvaAnexo');
      this.notificacaoService.erro(erro);
    });
  }

  ngOnDestroy(): void {

  }

}
